import { useQueryClient } from '@tanstack/react-query';
import { platformApi } from '../../../api/endpoints/platform';
import { RoleFormCore } from '../../../components/roles/RoleFormCore';
import type { PlatformRoleListItemLocal } from '../../../api/types/PlatformLocal';

interface Props {
    /** Si viene, el form edita ese rol (roleId fijo); si no, crea uno nuevo. */
    role?: PlatformRoleListItemLocal;
    /** Se llama tras crear/editar OK (ej. cerrar el modal del padre). */
    onDone?: () => void;
}

/**
 * Alta/edición de un rol PLATFORM (`/platform/roles`). Wrapper delgado sobre `RoleFormCore`: el
 * PermissionPicker ofrece SOLO los permisos `platform.*` (scope PLATFORM) y el scope del rol NO se pide
 * (lo autocalcula el backend, DEC-037). El nombre editable arranca del `displayName` del rol.
 */
export function PlatformRoleForm({ role, onDone }: Props) {
    const queryClient = useQueryClient();

    return (
        <RoleFormCore
            strategy={{
                supportsEdit: true,
                role: role ? { roleId: role.roleId } : undefined,
                initial: {
                    displayName: role?.displayName ?? '',
                    description: role?.description ?? '',
                    permissions: role?.permissions ?? [],
                },
                create: (body, opts) => platformApi.createPlatformRole(body, opts),
                update: role
                    ? (body) => platformApi.updatePlatformRole(role.roleId, body)
                    : undefined,
                invalidate: () => queryClient.invalidateQueries({ queryKey: ['platform', 'roles'] }),
                permissionPickerProps: { scopeFilter: 'PLATFORM' },
                onDone,
                idPrefix: 'prf',
                nameHint: 'Como quieres que se vea. Ej: Soporte Nivel 2',
                permissionsLabel: 'Permisos',
                createSubmitLabel: 'Crear',
            }}
        />
    );
}
